
    
(function($){

    var carousel_4_slides = 4;
    if ( $( window ).outerWidth() < 500 ) {
        carousel_4_slides = 1;
    } else if ( $( window ).outerWidth() < 750 ) {
        carousel_4_slides = 2;
    } else if ( $( window ).outerWidth() < 900 ) {
        carousel_4_slides = 3;
    }
    var carousels_4 = new Array();
    $('.carousel').each(function(i, item) {
        carousels_4[i] = $(item).bxSlider({
            controls: true,
            pager: false,
            minSlides: carousel_4_slides,
            maxSlides: carousel_4_slides,
            slideWidth: 310,
            slideMargin: 30,
            adaptiveHeight: true,
            prevText: '<span class="round-button"><i class="dashicons dashicons-arrow-left-alt2"></i></span>',
            nextText: '<span class="round-button"><i class="dashicons dashicons-arrow-right-alt2"></i></span>',
            infiniteLoop: false,
            hideControlOnEnd: true,
            autoHover: true,
            touchEnabled: false,
            keyboardEnabled: true
        });
    });

    var carousel_3_slides = 3;
    if ( $( window ).outerWidth() < 500 ) {
        carousel_3_slides = 1;
    } else if ( $( window ).outerWidth() < 750 ) {
        carousel_3_slides = 2;
    } 

    var carousels_3 = new Array();
    $('.carousel-3').each(function(i, item) {
        carousels_3[i] = $(item).bxSlider({
            controls: true,
            pager: false,
            minSlides: carousel_3_slides,
            maxSlides: carousel_3_slides,
            slideWidth: 450,
            slideMargin: 30,
            adaptiveHeight: true,
            prevText: '<span class="round-button"><i class="dashicons dashicons-arrow-left-alt2"></i></span>',
            nextText: '<span class="round-button"><i class="dashicons dashicons-arrow-right-alt2"></i></span>',
            infiniteLoop: false,
            hideControlOnEnd: true,
            autoHover: true,
            touchEnabled: false,
            keyboardEnabled: true
        });
    });
    
    var slider = $('.bx-slider').bxSlider({
        controls: true,
        pager: false,
        adaptiveHeight: false,
        prevText: '<span class="round-button"><i class="dashicons dashicons-arrow-left-alt2"></i></span>',
        nextText: '<span class="round-button"><i class="dashicons dashicons-arrow-right-alt2"></i></span>',
        infiniteLoop: false,
        hideControlOnEnd: true,
        autoHover: true,
        touchEnabled: false,
        keyboardEnabled: true
    });


    $(window).resize(function(){
        if ($( window ).outerWidth() < 500) {
            if (carousel_4_slides !== 1) {
                carousel_4_slides = 1;
                
                $.each(carousels_4, function(i, item) { 
                    ReloadCarousel(item, carousel_4_slides);
                });
            }
            if (carousel_3_slides !== 1) {
                carousel_3_slides = 1;
                
                $.each(carousels_3, function(i, item) { 
                    ReloadCarousel(item, carousel_3_slides);
                });
            }
        } else if ($( window ).outerWidth() < 750) {
            if (carousel_4_slides !== 2) {
                carousel_4_slides = 2;

                $.each(carousels_4, function(i, item) { 
                    ReloadCarousel(item, carousel_4_slides);
                });
            }
            if (carousel_3_slides !== 2) {
                carousel_3_slides = 2;
                
                $.each(carousels_3, function(i, item) { 
                    ReloadCarousel(item, carousel_3_slides);
                });
            }
        } else if ($( window ).outerWidth() < 900) {
            if (carousel_4_slides !== 3) {
                carousel_4_slides = 3;

                $.each(carousels_4, function(i, item) { 
                    ReloadCarousel(item, carousel_4_slides);
                });
            }
        } else {
            if (carousel_4_slides !== 4) {
                carousel_4_slides = 4;

                $.each(carousels_4, function(i, item) { 
                    ReloadCarousel(item, carousel_4_slides);
                });
            }
            if (carousel_3_slides !== 3) {
                carousel_3_slides = 3;

                $.each(carousels_3, function(i, item) { 
                    ReloadCarousel(item, carousel_3_slides);
                });
            }
        }
    });
    function ReloadCarousel(carousel, carousel_slides) {
        carousel.reloadSlider({
            controls: true,
            pager: false,
            minSlides: carousel_slides,
            maxSlides: carousel_slides,
            slideWidth: 310,
            slideMargin: 30,
            adaptiveHeight: true,
            prevText: '<span class="round-button"><i class="dashicons dashicons-arrow-left-alt2"></i></span>',
            nextText: '<span class="round-button"><i class="dashicons dashicons-arrow-right-alt2"></i></span>',
            infiniteLoop: false,
            hideControlOnEnd: true,
            autoHover: true,
            touchEnabled: false,
            keyboardEnabled: true
        });
    }
})(jQuery);